import { render, staticRenderFns } from "./CallEndedFeedback.vue?vue&type=template&id=32aa3cc8&scoped=true&"
import script from "./CallEndedFeedback.vue?vue&type=script&lang=js&"
export * from "./CallEndedFeedback.vue?vue&type=script&lang=js&"
import style0 from "./CallEndedFeedback.vue?vue&type=style&index=0&id=32aa3cc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aa3cc8",
  null
  
)

export default component.exports